export { default as LightMainMenu, default as MainMenu } from './LightMenu';
export { default } from './MainMenu';
